// extracted by mini-css-extract-plugin
module.exports = {"checkMark":"CheckMark_checkMark__2uYqj"};